import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const trainingApi = createApi({
  baseQuery,
  reducerPath: 'trainingApi',
  endpoints: builder => ({
    getTariningLogData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.TrainingLogs.getAll,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateTrainingLogSignature: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, id, data }) => ({
        url: `${formatString(endPoints.TrainingLogs.updateSignature, {
          key: urlKeys.id,
          value: id
        })}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getPageLevelSignData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, application_module_section }) => ({
        url: `${formatString(
          endPoints.TrainingLogs.getPageLevelSignature,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_module_section=${application_module_section}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updatePageLevelSignature: builder.query<any, any>({
      query: ({ site_id, study_id, country, username, password, application, data, application_module_section }) => ({
        url: `${formatString(
          endPoints.TrainingLogs.updatePageLevelSignature,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&username=${username}&password=${password}&application=${application}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateTrainingLog: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, id, data }) => ({
        url: `${formatString(
          endPoints.TrainingLogs.UpdateTrainingLog,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.id, value: id }
        )}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    deleteTrainingLog: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, id, data }) => ({
        url: `${formatString(endPoints.TrainingLogs.trainingLogDelete, {
          key: urlKeys.id,
          value: id
        })}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}`,
        method: 'PATCH',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    deleteTrainingDoc: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, id, data, documentName }) => ({
        url: `${formatString(
          endPoints.TrainingLogs.tariningDocDelete,
          { key: urlKeys.id, value: id },
          { key: urlKeys.documentName, value: documentName }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}`,
        method: 'PATCH',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createTrainingLog: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.TrainingLogs.trainingLogcreate,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useGetTariningLogDataQuery,
  useUpdateTrainingLogSignatureMutation,
  useLazyGetPageLevelSignDataQuery,
  useLazyUpdatePageLevelSignatureQuery,
  useUpdateTrainingLogMutation,
  useLazyCreateTrainingLogQuery,
  useDeleteTrainingDocMutation,
  useDeleteTrainingLogMutation
} = trainingApi;
